import PropTypes from 'prop-types';
import {
  Button,
  Link,
  List,
  ListItem,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
} from '@chakra-ui/react';
import { useRef } from 'react';

export function CreditsModal({ isOpen, onClose }) {
  const initialRef = useRef(null);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      closeOnOverlayClick
      initialFocusRef={initialRef}
    >
      <ModalOverlay />
      <ModalContent layerStyle="base">
        <ModalHeader>TSL Roller</ModalHeader>
        <ModalCloseButton size="sm" />
        <ModalBody ref={initialRef}>
          <License />
        </ModalBody>
        <ModalFooter>
          <Button size="sm" onClick={onClose} ref={initialRef}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export function License({ size = 'sm', linkColorScheme, linkVariant }) {
  return (
    <Stack fontSize={size}>
      <Text>Coded with 💜 by Kona Goodhart.</Text>
      <Text>
        Beautiful dice rolling animations by{' '}
        <Link
          colorScheme={linkColorScheme}
          variant={linkVariant}
          href="https://www.mrroboman.com/"
        >
          Rob Kayson
        </Link>
        . 🎲
      </Text>
      <Text>
        This app is based on{' '}
        <Link
          colorScheme={linkColorScheme}
          variant={linkVariant}
          href="https://thirstyswordlesbians.com"
        >
          Thirsty Sword Lesbians
        </Link>
        , designed by April Kit Walsh and published by Evil Hat Productions,
        LLC, and uses material from it pursuant to the open license available at{' '}
        <Link
          colorScheme={linkColorScheme}
          variant={linkVariant}
          href="https://poweredbylesbians.com"
        >
          poweredbylesbians.com
        </Link>
        .
      </Text>
      It also features playbooks by:
      <List>
        <ListItem>
          Erin Edwards (<i>The Bloody</i>)
        </ListItem>
        <ListItem>
          Christie R. Fremon (<i>The Dream Mirror</i>)
        </ListItem>
        <ListItem>
          Katherine Cross (<i>The Hologoddess</i>)
        </ListItem>
        <ListItem>
          Ash Cheshire (<i>The Investigator</i>)
        </ListItem>
        <ListItem>
          Pam Punzalan (<i>The Legion</i>)
        </ListItem>
        <ListItem>
          Alexis Sara (<i>The Matriarch</i>)
        </ListItem>
        <ListItem>
          Mariam Ahmad (<i>The Naga</i>)
        </ListItem>
        <ListItem>
          Jan Martin (<i>The Sun Hand</i>)
        </ListItem>
        <ListItem>
          Bryanna Hitchcock (<i>The Troubadour</i>)
        </ListItem>
        .
      </List>
      <Text>
        TSL is truly a delight,{' '}
        <Link
          colorScheme={linkColorScheme}
          variant={linkVariant}
          href="https://sword.gay/"
        >
          go get yourself a copy
        </Link>
        .
      </Text>
    </Stack>
  );
}

License.propTypes = {
  linkColorScheme: PropTypes.string,
  linkVariant: PropTypes.oneOf(['', 'shadow', 'tealAccent']),
};
